export default {
  emailUs: [
    "cancelOrder",
    "generalDeliveryQueries",
    "helpWithDeliveryProblem",
    "makingChangesToMyDelivery",
    "trackMyOrder",
    "returningOrExchanging",
    "refundsBooths",
    "refundsCollectedJL",
    "refundsDobbiesShellSelect",
    "refundsExternalWithinTwoWeeks",
    "refundsJL",
    "refundsOverTwoWeeks",
    "refundsRoyalMail",
    "refundsWaitrose",
    "refundsWithinTwoWeeks",
    "generalPolicyQuestions",
    "other",
    "productStockInformation",
    "placeEditCancelOrder",
    "myJLMembership",
    "myAccountOnline",
    "complaints",
  ],
  liveChat: [
    { name: "Delivery", pct: 70 },
    { name: "TechnicalSupport", pct: 50 },
    { name: "ProductStockInfo", pct: 100 },
  ],
  partnersLiveChat: ["ProductStockInfo"],
  liveChatEmailUs: ["problemsWithProduct|electrical"],
};
